RivalIQ.apps.CompanyProfile.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmptyPresence = Marionette.ItemView.extend({
        template: '#companyProfileEmptyPresenceTemplate'
    });
});
